/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { alpha } from '@mui/material';
import { Theme } from '@mui/material/styles';

const EntryBoxViewStyles = makeStyles()((theme: Theme) => ({
	image: {
		height: '132px',
		'& img': {
			width: '100%',
			height: '132px',
			objectFit: 'cover',
			borderTopLeftRadius: theme.spacing(1),
			borderTopRightRadius: theme.spacing(1),
		},
		'&:hover': {
			cursor: 'pointer',
		},
	},

	divider: {
		margin: theme.spacing(1, 0),
	},

	thumbBox: {
		textAlign: 'center',
		'& svg': {
			width: '16px',
			color: alpha(theme.palette.common.black, 0.6),
		},
		'& button': {
			padding: theme.spacing(1.25, 1),
		},
	},

	approved: {
		borderTopLeftRadius: theme.spacing(1),
		borderTopRightRadius: theme.spacing(1),
		backgroundColor: '#188F06',
		opacity: '0.9',
		'& img': {
			opacity: '0.5',
		},
	},

	rejected: {
		borderTopLeftRadius: theme.spacing(1),
		borderTopRightRadius: theme.spacing(1),
		backgroundColor: '#F4430B',
		opacity: '0.9',
		'& img': {
			opacity: '0.45',
		},
	},

	placeholder: {
		borderTopLeftRadius: theme.spacing(1),
		borderTopRightRadius: theme.spacing(1),
		backgroundColor: alpha(theme.palette.common.black, 0.3),
		height: '100%',
		'& svg': {
			width: '80px',
			height: 'auto',
			color: alpha(theme.palette.common.black, 0.35),
		},
	},

	thumbApproved: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '44px',
		'& svg': {
			color: alpha('#188F06', 0.6),
		},
	},

	thumbRejected: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '44px',
		'& svg': {
			color: alpha('#F4430B', 0.6),
		},
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default EntryBoxViewStyles;
